import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Comparison from "@/pages/Comparison";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import Cart from "@/pages/Cart";
import OrderForm from "@/pages/OrderForm";
import DealerLogin from "@/pages/DealerLogin";
import DealerApply from "@/pages/DealerApply";
import DealerPortal from "@/pages/DealerPortal";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminDealers from "@/pages/admin/AdminDealers";
import AdminOrders from "@/pages/admin/AdminOrders";

import NotFound from "@/pages/NotFound";

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#081b3d",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#fdfbf7",
            borderRadius: 0,
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/urunler" element={<Products />} />
            <Route path="/urunler/:slug" element={<ProductDetail />} />
            <Route path="/kalite-karsilastirma" element={<Comparison />} />
            <Route path="/hakkimizda" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/sepet" element={<Cart />} />
            <Route path="/siparis" element={<OrderForm />} />
            <Route path="/bayi-girisi" element={<DealerLogin />} />
            <Route path="/bayi-basvuru" element={<DealerApply />} />
            <Route element={<ProtectedRoute redirectTo="/bayi-girisi" />}>
              <Route path="/bayi-panel" element={<DealerPortal />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<ProtectedRoute role="admin" redirectTo="/admin/login" />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/products" element={<AdminProducts />} />
              <Route path="/admin/blog" element={<AdminBlog />} />
              <Route path="/admin/contacts" element={<AdminContacts />} />
              <Route path="/admin/dealers" element={<AdminDealers />} />
              <Route path="/admin/orders" element={<AdminOrders />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}
